import { Video } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function VideoIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Video
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
